import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class SubscriptionService {

    constructor(private apiHttp: ApiHttp) {
    }

    public createOrRemoveSubscriptionCard(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminSubscription/CreateOrRemoveSubscriptionCard', data, messageService);
    }

    public getProducts(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminSubscription/GetProducts', data, messageService);
    }
}
